<template>
  <div class="wc-punch-card">
    <h5 class="wc-punch-card__name pt-3 mb-0 text-primary">
      {{ card.name }}
    </h5>
    <p class="wc-punch-card__details mb-0 font-size-sm">{{ card.details }}</p>
    <div class="d-flex align-items-center">
      <div class="wc-punch-card__icons my-2">
        <font-awesome-icon
          class="wc-punch-card__icon"
          v-for="i in required"
          :key="i"
          :icon="i <= punches ? 'star' : ['far', 'star']"
        />
      </div>
      <strong class="wc-punch-card__completed pl-3" v-if="card.completedCards">
        <template v-if="card.completedCards > 1">
          {{ card.completedCards }}
        </template>
        {{ $t('readyToRedeem') }}
      </strong>
    </div>

    <p class="wc-punch-card__expiration font-size-sm pt-2" v-if="card.expiration">
      {{ $t('goodThrough') }}{{ card.expiration | formatDate }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'WCPunchCard',
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  computed: {
    required() {
      return this.card.requiredPunches;
    },
    punches() {
      return this.card.currentPunches;
    },
    remaining() {
      return this.required - this.punches;
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-punch-card:not(:last-child) {
  margin-bottom: 1rem;
}
.wc-punch-card__icon {
  font-size: $font-size-4xl;
  margin-right: $margin-2;
  color: var(--primary, $primary);
}
</style>
